import { getAuthUserFromLocalStorage } from './LocalStorage';

export const trackGAEvent = (
  eventName: string,
  params?: Record<string, string | number>
): void => {
  if (typeof window !== 'undefined' && (window as any).gtag) {
    const user = getAuthUserFromLocalStorage();
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.gtag('event', eventName, { ...params, utm_id: user?.email });
  }
};

export default trackGAEvent;
